export const calculateCorrederaGrande = (width, height) => {
  const verticalElements = {
    'Marco': Math.floor(height + 5),
    'Refuerzo Marco': Math.floor(height - 130),
    'Hoja Grande': Math.floor(height - 97),
    'Refuerzo Hoja Grande': Math.floor(height - 282),
    'Junquillo': Math.floor(height - 240),
  };

  const horizontalElements = {
    'Marco': Math.floor(width + 5),
    'Refuerzo Marco': Math.floor(width - 130),
    'Hoja Grande': Math.floor(width / 2 - 4),
    'Refuerzo Hoja Grande': Math.floor(width / 2 - 188.5),
    'Junquillo': Math.floor(width / 2 - 146.5),
  };

  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  // Calcular barras para elementos verticales
  for (const [perfil, largo] of Object.entries(verticalElements)) {
    const cantidadPiezas = (perfil === 'Junquillo' || perfil === 'Hoja Grande' || perfil === 'Refuerzo Hoja Grande') ? 4 : 2;
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  // Calcular barras para elementos horizontales y combinar con verticales
  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = (perfil === 'Junquillo' || perfil === 'Hoja Grande' || perfil === 'Refuerzo Hoja Grande') ? 4 : 2;
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Corredera Grande',
    photo: "/fotos/correderagrande.jpg",
  };
};

export const calculateVidriosCorrederaGrande = (width, height) => {
  const vidrioHeight = Math.floor(height - 248);
  const vidrioWidth = Math.floor(width / 2 - 154);

  return { vertical: vidrioHeight, horizontal: vidrioWidth };
};
